import { Component, OnInit } from '@angular/core';
import { SweetAlertHelper } from 'app/core/helpers/sweet-alert-helper.service';

@Component({
  selector: 'app-t2-content-main',
  templateUrl: './t2-content-main.component.html',
  styleUrls: ['./t2-content-main.component.scss']
})
export class T2ContentMainComponent implements OnInit {
  animated: boolean;

  constructor(private sweetAlertHelper: SweetAlertHelper) {

  }

  ngOnInit() {
    if (!localStorage.getItem('monitored')) {
      this.sweetAlertHelper.createCustomAlert({
        type: 'info',
        title: 'Your actions are being monitored for security purpose.'
      }).then(() => {
        localStorage.setItem('monitored', 'ok');
      });
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/trip2-theme/components/t2-content-main/t2-content-main.component.ts